<template>
  <div
    class="height-all main-bg-effect"
    :class="`main-bg-effect--${createRenderType}`"
  >
    <!-- <video
      v-if="createRenderType === 'pc'"
      ref="refVideo"
      src="@/assets/media/mainbg.mp4"
      :autoplay="false"
      loop
      muted
    ></video> -->
  </div>
</template>

<script setup>
import { onMounted, reactive } from "vue";

import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);

const refVideo = ref(null);
// const init = () => {
//   var filter = document.querySelector("#turbulence");
//   var frames = 0;
//   var rad = Math.PI / 180;
//   var lastTime = 0;
//   const fpsInterval = 1000 / 60; // 60 FPS
//   const aurora = document.querySelector(".g-wrap");
//   let x = 100;
//   let y = 100;

//   function freqAnimation(time) {
//     // 控制更新频率
//     if (time - lastTime >= fpsInterval) {
//       lastTime = time;
//       var bfx = 0.01;
//       var bfy = 0.01;
//       frames += Math.random() * 1;
//       bfx += +(0.0005 * Math.cos(frames * rad)).toFixed(8);
//       bfy += +(0.0005 * Math.sin(frames * rad)).toFixed(8);
//       var bf = bfx.toString() + " " + bfy.toString();
//       filter.setAttributeNS(null, "baseFrequency", bf);

//       let directionX = (Math.random() - 0.5) * 0.15;
//       let directionY = (Math.random() - 0.5) * 0.15;
//       x += directionX;
//       y += directionY;
//       aurora.style.setProperty("--x", `${x}%`);
//       aurora.style.setProperty("--y", `${y}%`);
//     }
//     window.requestAnimationFrame(freqAnimation);
//   }

//   window.requestAnimationFrame(freqAnimation);
// };

const playVideo = () => {
  if (!refVideo.value) return;
  if (refVideo.value?.playState === "playing") return;
  refVideo.value?.play();
};
const init = () => {
  refVideo.value?.play();
  document.addEventListener("click", playVideo);
};

onMounted(() => {
  // init();
});
onUnmounted(() => {
  // document.removeEventListener("click", playVideo);
});
</script>

<style lang="scss">
.main-bg-effect {
  border-radius: 16px 16px 0 0;
  background: linear-gradient(180deg, rgba(58, 27, 118, 0.4) 0%, #000000 100%);
  // background-position: center;
  overflow: hidden;
  // background: url(@/assets/img/main-bg-wp.webp);
  // background-size: 100% 100%;
  opacity: 0.8;
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &.main-bg-effect--mobile {
    // background: url(@/assets/img/main-bg-mobile-wp.webp);
    // background-size: 100% 100%;
    opacity: 1;
    video {
      display: none;
    }
  }
}
</style>
